let _ = t => t,
  _t;
import { createGlobalStyle } from 'styled-components';
import { HEFFALUMP } from 'HubStyleTokens/colors';
import { useTourContext } from '../hooks/tour';
import { jsx as _jsx } from "react/jsx-runtime";
const SKELETON_STYLES = `
  content: '';
  background-color: ${HEFFALUMP};
  display: block;
`;
const getExclusionSelector = ({
  exclusionSelectors = []
}) => {
  return exclusionSelectors.length > 0 ? `:not(${exclusionSelectors.join(', ')})` : '';
};
const getInvertedExclusionSelector = ({
  exclusionSelectors = []
}) => {
  return exclusionSelectors.length > 0 ? exclusionSelectors.join(', ') : '';
};
const ObscureNavGlobalStyle = createGlobalStyle(_t || (_t = _`
  /* Prevent clicks from registering on any part of the nav */
  #hs-vertical-nav-root, #hs-global-toolbar-root {
    pointer-events: none;
  }

  /* The top toolbar */
  #hs-global-toolbar {
    /* Hide the searchbar, toolbar icons, and dividers */
    #hs-search-react, #hs-global-toolbar-icons li > *, #hs-global-toolbar-icons > div:empty {
      display: none;
    }

    /* Without filling content, assign a width to icons */
    #hs-global-toolbar-icons li:not([data-portal-hook="account-menu"]) {
      width: 32px;

      /* For the Spotlight Link */
      &:has(#hs-global-toolbar-spotlight-list-item) {
        margin-right: 15px !important;
        width: 200px;

        &::after {
          width: 100%;
        }
      }
    }

    /* Apply skeleton boxes to the searchbar and toolbar icons */
    div:has(#hs-search-react)::after, #hs-global-toolbar-icons li:not([data-portal-hook="account-menu"])::after {
      ${0}
      width: 32px;
      height: 20px;
      border-radius: 3px;

      /* This prevents varying margins on some toolbar icons making the boxes appear smaller */
      margin: 0 6px;
    }

    /* Padding between the account menu and toolbar icons */
    #hs-global-toolbar-icons [data-portal-hook="account-menu"] {
      padding-left: 12px;
    }

    /* Apply a skeleton circle instead of the account icon */
    #hs-global-toolbar-icons [data-portal-hook="account-menu"]::before {
      ${0}
      width: 20px;
      height: 20px;
      border-radius: 10px;
    }

    /* Apply a skeleton box instead of the account menu */
    #hs-global-toolbar-icons [data-portal-hook="account-menu"]::after {
      ${0}
      width: 68px;
      height: 15px;
      margin: 0 8px;
      border-radius: 3px;
    }

    /* Apply a width to the search bar skeleton */
    div:has(#hs-search-react)::after {
      width: 100%;

      /* These widths are copied from the current search bar style */
      max-width: 550px;
      min-width: 200px;
    }
  }

  /* The vertical nav */
  #hs-vertical-nav {
    /* Apply a centered skeleton box to each vertical nav item */
    li {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 52px;

      /* Hide every vertical nav item save excluded items */
      & > *${0} {
        display: none;
      }

      /*  Add a skeleton box for every vertical nav item save excluded items */
      &${0}::after {
        ${0}
        width: 45%;
        height: 18px;
        border-radius: 3px;
        margin-top: 5px;
      }

      /* Re-enable mouse events for excluded items to clicks and hover events work */
      &:has(${0}) {
        pointer-events: all;
      }
    }

    /* When a first-level vertical nav item is hovered or pinned */
    &.isHovering li, &.isPinned li {
      margin-left: 12px;

      &::after {
        /* Make the vertical nav item skeleton boxes expand horizontally */
        width: 90% !important;
      }
    }
  }
`), SKELETON_STYLES, SKELETON_STYLES, SKELETON_STYLES, getExclusionSelector, getExclusionSelector, SKELETON_STYLES, getInvertedExclusionSelector);
const ObscureNav = ({
  requireActiveTour = true,
  exclusionSelectors
}) => {
  const tourContext = useTourContext();
  const isTourActive = tourContext && tourContext.tour && tourContext.tour.getHandler().isActive;
  if (requireActiveTour && !isTourActive) {
    return null;
  }
  return /*#__PURE__*/_jsx(ObscureNavGlobalStyle, {
    exclusionSelectors: exclusionSelectors
  });
};
export default ObscureNav;